import { render, staticRenderFns } from "./business-dashboard.vue?vue&type=template&id=ef6bc746&"
import script from "./business-dashboard.vue?vue&type=script&lang=js&"
export * from "./business-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./business-dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports